export enum ImmobilizationConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'immobilization/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'immobilization/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_OPTION = 'immobilization/SET_OPTION',
  SET_DEVICES_USED = 'immobilization/SET_DEVICES_USED',
  SET_ASSESSMENT = 'immobilization/SET_ASSESSMENT',
  SET_SITE = 'immobilization/SET_SITE',
  SET_RESPONSE = 'immobilization/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'immobilization/SET_RESPONSE_PNNV',
  SAVE_IMMOBILIZATION = 'immobilization/SAVE_IMMOBILIZATION',
  RESET_STATE = 'immobilization/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'immobilization/SET_ADD_TO_TIMELINE',
  SET_STATE = 'immobilization/SET_STATE',
  SET_DATE_TIME = 'immobilization/SET_DATE_TIME',
  SET_ASSESSED_BY = 'immobilization/SET_ASSESSED_BY',
  ON_SELECT_IMMOBILIZATION = 'immobilization/ON_SELECT_IMMOBILIZATION',
  SET_UPDATE_INPUT_ROWS = 'immobilization/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'immobilization/SET_DATE',
  SET_TIME = 'immobilization/SET_TIME',
  SET_ATTEMPTS = 'immobilization/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'immobilization/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'immobilization/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'immobilization/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'immobilization/SET_PTA',
  SET_COMMENTS = 'immobilization/SET_COMMENTS',
  SET_SIZE = 'immobilization/SET_SIZE',
  SET_ROLE_PERFORMING = 'immobilization/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'immobilization/SET_ROLE_PERFORMING_PNNV',
}
